const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1']

const matchesDomain = (hostname, domain) => hostname === domain || hostname.endsWith(`.${domain}`)

export const isAllowedRedirectURL = (value, { allowedDomains, allowLocalhost = false } = {}) => {
  if (typeof value !== 'string' || !value) return false

  let url
  try {
    url = new URL(value)
  } catch {
    return false
  }

  const { protocol, hostname } = url

  if (allowLocalhost && LOCAL_HOSTNAMES.includes(hostname)) return ['http:', 'https:'].includes(protocol)
  if (protocol !== 'https:') return false
  if (!allowedDomains) return true

  return allowedDomains.some((domain) => matchesDomain(hostname, domain))
}

export const decodeRedirectURL = (value) => {
  try {
    return decodeURIComponent(value)
  } catch {
    return null
  }
}
